export interface CreateAuthConfigRequest {
    authenticationConfigApplicationId: number | undefined,
    authenticationConfigGenerateLink: string,
    authenticationConfigGenerateOtp: string,
    authenticationConfigIsPasswordEncrypted: string,
    authenticationConfigNonReusableRecentPassword: string,
    authenticationConfigPasswordAttribute: string,
    authenticationConfigRoleIdAttribute: string,
    authenticationConfigSendEmail: string,
    authenticationConfigSendSms: string,
    authenticationConfigUserEntity: string,
    authenticationConfigUsernameAttribute: string
}

export const CreateAuthConfigRequestInit: CreateAuthConfigRequest = {
    authenticationConfigApplicationId: 0,
    authenticationConfigGenerateLink: "",
    authenticationConfigGenerateOtp: "",
    authenticationConfigIsPasswordEncrypted: "",
    authenticationConfigNonReusableRecentPassword: "",
    authenticationConfigPasswordAttribute: "",
    authenticationConfigRoleIdAttribute: "",
    authenticationConfigSendEmail: "",
    authenticationConfigSendSms: "",
    authenticationConfigUserEntity: "",
    authenticationConfigUsernameAttribute: "",
}